/* eslint-disable */

import OpeningTitleVideo from './Videos/opening-title.webm'
import ClosingTitleVideo from './Videos/closing-title.webm'
import UnrealWorldVideo from './Videos/unreal-world.webm'
import ChesmacVideo from './Videos/chesmac.webm'
import UunoTurhapuroVideo from './Videos/uuno-turhapuro.webm'
import MaxPayneVideo from './Videos/max-payne.webm'
import AngryBirdsVideo from './Videos/angrybirds.webm'
import SanxionVideo from './Videos/sanxion.webm'
import SlicksNSlideVideo from './Videos/slicks-n-slide.webm'
import SnakeVideo from './Videos/snake.webm'
import ClashOfClansVideo from './Videos/clash-of-clans.webm'

const SlidesFi = [
  {
    index: 0,
    mainLayoutType: 'full',
    content: {
      components: [
        {
          componentType: 'video',
          src: OpeningTitleVideo,
          bgColor: '#0000FF'
        }
      ]
    }
  },
  {
    index: 1,
    mainLayoutType: 'split',
    content: {
      left: {
        main: {
          components: [
            {
              componentType: 'heading',
              headingLevel: '1',
              text: 'Chesmac (1979)'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Tarina:'
            },
            {
              componentType: 'text',
              text: 'Erään Raimo Suonion vapaa-ajan projektina syntynyt shakkipeli Chescmac on Suomen kaikkien aikojen ensimmäinen kaupallinen tietokonepeli. Vuonna 1979 työttömäksi hetkellisesti jäänyt Suonio kehitti Chesmacin huvikseen reilussa kuukaudessa kotimaiselle Telmac-rakennussarjatietokoneelle, jonka laskentateho ei 1970-luvun lopulla ollut häävi. Vaikka Suonio ei ollut ammattimainen pelisuunnittelija, niin uteliaana muotoilijasieluna hän halusi kokeilla, pystyisikö Telmac TMC-1800 suoriutumaan shakkipeliin vaadittavista toiminnoista. Se pystyi, erittäin hitaasti mutta silti. Klassikko oli syntynyt.'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Tiesitkö että:'
            },
            {
              componentType: 'text',
              text: 'Chesmac, jos joku, oli oman aikansa utopia. Kone, joka osasi ajatella tekoälyllään strategisesti. C-kasetille julkaistu Chesmac oli myös kaupallinen menestys, jota myytiin Raimo Suonion uudesta työpaikasta eli helsinkiläisestä Topdata-liikkeestä käsin huimaavat 104 kappaletta. 1970- ja 1980-lukujen Suomessa se oli kunnioitettava luku. Chesmac on edelleen ladattavissa netistä. Shakista pelin suunnittelija itse ei, ironista sinänsä, koskaan innostunut.'
            }
          ]
        },
        footnotes: {
          components: [
            {
              componentType: 'text',
              text: 'Pääsuunnittelija: Raimo Suonio',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Julkaisija: Raimo Suonio / Topdata',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Alusta: Telmac TMC-1800',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Formaatti: C-kasetti',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Genre: Pulmapeli / yksinpeli',
              style: 'small'
            },
          ]
        },
      },
      right: {
        components: [
          {
            componentType: 'video',
            src: ChesmacVideo
          },
        ]
      }
    }
  },
  {
    index: 2,
    mainLayoutType: 'split',
    content: {
      left: {
        main: {
          components: [
            {
              componentType: 'heading',
              headingLevel: '1',
              text: 'Sanxion (1986)'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Tarina:'
            },
            {
              componentType: 'text',
              text: 'Suomalaisen pelisuunnittelun pioneerin Stavros Fasoulasin (1968-) kehittämä Sanxion on yksi 1980-luvun merkittävimmistä yksinpelattavista räiskintäpeleistä koko maailmassa. Poikkeuksellisen Sanxionista teki se, että kuvaruutu oli jaettuun kahtia niin, että pelaaja pystyi samanaikaisesti näkemään avaruusaluksensa sekä sivulta että ylhäältä. Sanxion oli ensisijaisesti aikuisille tarkoitettu haastava peli, joka sorminäppäryyden lisäksi vaati myös taktista silmää. Äänimaailmaltaan Sanxion oli suorastaan vallankumouksellinen.'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Tiesitkö että:'
            },
            {
              componentType: 'text',
              text: 'Kun Sanxion 1986 ilmestyi, legendaarinen pelitoimittaja Niko Nirvi kutsui sen suunnittelijaa Stavros Fasoulasia ”tietokonepelien Paavo Nurmeksi” Suomen kuuluisimman kestävyysjuoksijan mukaan. Tunnetun brittiläisen pelisäveltäjän Ron Hubbardin (1956-) SID-tekniikalla luoma venäläissäveltäjä Sergey Prokofievin Romeo ja Juliastakin tuttuun Dance of the Knightsiin perustuva Sanxonin elektorinen tunnusmusiikki on yksi pelimaailman ehdottomista klassikoista, joka muistetaan yhä kaikkialla.'
            }
          ]
        },
        footnotes: {
          components: [
            {
              componentType: 'text',
              text: 'Pääsuunnittelija: Stavros Fasoulas',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Julkaisija: Thamalus',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Alusta: Commodore 64',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Formaatti: C-kasetti / levyke',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Genre: Räiskintäpeli / yksinpeli',
              style: 'small'
            },
          ]
        },
      },
      right: {
        components: [
          {
            componentType: 'video',
            src: SanxionVideo
          },
        ]
      }
    }
  },
  {
    index: 3,
    mainLayoutType: 'split',
    content: {
      left: {
        main: {
          components: [
            {
              componentType: 'heading',
              headingLevel: '1',
              text: 'Uuno Turhapuro muuttaa maalle (1986)'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Tarina:'
            },
            {
              componentType: 'text',
              text: 'Videopelisuunnittelija Pasi Hytösen jo lukioikäisenä parissa kuukaudessa ohjelmoima Uuno Turhapuro muuttaa maalle on ensimmäinen kotimaisesta elokuvasta tehty digitaalinen lisenssipeli. Odotukset olivat kovat, sillä olihan Vesa-Matti Loirin näyttelemä Uuno Turhapuron hahmo 1980-luvun Suomessa megasuosittu. Kyseessä on graafisesti suhteellisen korkeatasoinen toimintapeli, jossa ampumisen sijaan kynnetään peltoa, juostaan metsässä ja harrastetaan paljasjalkavesihiihtoa. Sprite- ja merkkigrafiikalla ohjelmoitua Uunoa pelaaja ohjaa ylös-alas-akselilla. Ohjelmointikielenä oli Commodoren oma kieli. Lähdekoodinsa Hytönen oli globaalina luonteena kopioinut ulkomaisista lehdistä.'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Tiesitkö että:'
            },
            {
              componentType: 'text',
              text: 'Uuno Turhapuro muuttaa maalle muistetaan lähes turhauttavan korkeasta vaikeustasosta. Suunnittelija Hytönen oli huolissaan, että kevyestä elokuvasta tulisi liian helppo peli. Ei tullut. Erään kriitikon mukaan Uuno Turhapuro muuttaa maalle -peliä pelaavat enää ”sadistit”. Yhteensä peliä on myyty Suomessa reilut 2 000 kappaletta.'
            }
          ]
        },
        footnotes: {
          components: [
            {
              componentType: 'text',
              text: 'Pääsuunnittelija: Pasi Hytönen',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Julkaisija: Amersoft',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Alusta: Commodore 64',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Formaatti: C-kasetti / levyke',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Genre: Toimintapeli / yksinpeli',
              style: 'small'
            },
          ]
        },
      },
      right: {
        components: [
          {
            componentType: 'video',
            src: UunoTurhapuroVideo
          },
        ]
      }
    }
  },
  {
    index: 4,
    mainLayoutType: 'split',
    content: {
      left: {
        main: {
          components: [
            {
              componentType: 'heading',
              headingLevel: '1',
              text: 'UnReal World (1982)'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Tarina:'
            },
            {
              componentType: 'text',
              text: 'Esihistoriallista Suomea muistuttavaan fantasiamaailmaan sijoittuva UnReal World on selviytymispeli, joka ei pääty välttämättä koskaan. Kyse on pelin toisen suunnittelijan Sami Maarasen elämäntyöstä, joka on jatkunut keskeytyksettä vuodesta 1982 lähtien. Peliä päivitetään siis yhä tasaisin väliajoin. UnReal World ammentaa rautakauden (500 eea-1300 jaa) aikaisista suomalaisista kansantaruista. Luonto on vahvasti läsnä. Pelissä selviytyäkseen täytyy olla vahva ja kekseliäs. Realistisuus on UnReal Worldin sydän. Esimerkiksi pelihahmon iho vaurioituu paleltuessaan.'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Tiesitkö että:'
            },
            {
              componentType: 'text',
              text: 'UnReal Worldin hahmoihin kuuluu esimerkiksi kalastaja sekä lumimyrskyjen ja villieläinten keskellä elävä erakkohahmo. UnReal World ottaa päivityksissään huomioon myös todellisen maailman. Esimerkiksi ilmastonmuutokseen liittyvät asiat näkyvät myös pelissä. Viime vuosina UnReal World on saanut runsaasti kansainvälistäkin huomiota.'
            }
          ]
        },
        footnotes: {
          components: [
            {
              componentType: 'text',
              text: 'Pääsuunnittelija: Sami Maaranen, Erkka Lehmus',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Julkaisija: Enormous Elk',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Alusta: Windows / Mac OS X / Linux',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Formaatti: C-kasetti / levyke / nyt ladattavissa netistä',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Genre: Päättymätön eloonjäämisseikkailu / yksinpeli',
              style: 'small'
            },
          ]
        },
      },
      right: {
        components: [
          {
            componentType: 'video',
            src: UnrealWorldVideo
          },
        ]
      }
    }
  },
  {
    index: 5,
    mainLayoutType: 'split',
    content: {
      left: {
        main: {
          components: [
            {
              componentType: 'heading',
              headingLevel: '1',
              text: 'Slicks ‘n Slide (1993)'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Tarina:'
            },
            {
              componentType: 'text',
              text: 'Timo ja Juha Kauppisen suunnittelema Slicks ’n’ Slide kilpa-ajopeli kuuluu lajityyppinsä klassikoihin. Perusidealtaan peli on yksinkertainen: Aja autolla lyhyellä radalla ympyrää kovempaa kuin muut. Graafisesti Slicks ’n’ Slide ei ollut loistelias, mutta se pystyi välittämään poikkeuksellisen onnistuneesti sen maagisen tunteen, joka kilpa-ajamiseen usein liitetään. Pelin tekoäly oli fiksu, mutta Slicks ’n’ Sliden koukuttavin ominaisuus oli mahdollisuus neljän ihmisen moninpeliin. Ja kyllä, he kaikki käyttivät pelaamiseen yleensä yhtä ja samaa näppäimistöä. Siitä se riemu syntyi.'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Tiesitkö että:'
            },
            {
              componentType: 'text',
              text: 'Ajoneuvovalikoimaltaan Slicks ’n’ Slide oli harvinaisen monipuolinen. Autojen lisäksi valittavana oli esimerkiksi moottoripyörä, panssarivaunu ja ufo. Myöhemmissä versioissa mukaan tulivat lisävarusteena myös erilaiset aseet. Slicks ’n’ Slide edusti osallistavaa muotoilua, sillä pelaajat pystyivät tekemään omia ratoja kenttäeditorin avulla. Peli on yhä saatavilla netistä.'
            }
          ]
        },
        footnotes: {
          components: [
            {
              componentType: 'text',
              text: 'Pääsuunnittelija: Timo Kauppinen / Juha Kauppinen',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Julkaisija: Maksuton tietokoneohjelma Shareware',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Alusta: MS-DOS / Microsoft Windows',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Formaatti: Alkujaan levyke / nyt ladattavissa netistä',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Genre: Ajopeli / yksinpeli / moninpeli',
              style: 'small'
            },
          ]
        },
      },
      right: {
        components: [
          {
            componentType: 'video',
            src: SlicksNSlideVideo
          },
        ]
      }
    }
  },
  {
    index: 6,
    mainLayoutType: 'split',
    content: {
      left: {
        main: {
          components: [
            {
              componentType: 'heading',
              headingLevel: '1',
              text: 'Snake (1997)'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Tarina:'
            },
            {
              componentType: 'text',
              text: 'Alun perin 1970-luvun ulkomaisiin klassikkopeleihin perustuva Nokian Matopeli lienee maailmalla kuuluisampi kuin yksikään yrityksen matkapuhelimista. Se kertoo kaiken siitä, kuinka suosittu tämä tavattoman yksinkertainen, mutta koukuttava Mato 1990-luvun lopulla oli. Alkuperäisen lisäksi Nokia julkaisi Madostaan useita muitakin kehittyneempiä versioita, joista yksikään ei, hassua kyllä, onnistunut tavoittamaan alkuperäisen Madon hypnoottista vetovoimaa.'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Tiesitkö että:'
            },
            {
              componentType: 'text',
              text: 'Kuten monet ikoniset työt muotoilun historiassa, myös Nokian alkuperäinen Matopeli syntyi vähän vahingossa. Pelin suunnittelijaksi valittu Taneli Armanto työskenteli 1997 Nokialla 6110-puhelimen kehitystiimissä ja hänen luultiin olevan osaava pelintekijä. Taneli Armanto kuitenkin sekoitettiin vahingossa hänen lähes samannimiseen sukulaiseensa, jolla todella oli pelisuunnittelusta enemmän kokemusta. Sekaannuksesta huolimatta Taneli Armanto jatkoi hapuilevaa kehitysprosessiaan, jonka seurauksena syntyi yksi populaarikulttuurin kuuluisimmista peleistä.'
            }
          ]
        },
        footnotes: {
          components: [
            {
              componentType: 'text',
              text: 'Pääsuunnittelija: Taneli Armanto',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Julkaisija: Nokia',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Alusta: Nokia 6110 ja muut Nokian matkapuhelimet',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Formaatti: Mobiilipeli',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Genre: taitopeli / yksinpeli',
              style: 'small'
            },
          ]
        },
      },
      right: {
        components: [
          {
            componentType: 'video',
            src: SnakeVideo
          },
        ]
      }
    }
  },
  {
    index: 7,
    mainLayoutType: 'split',
    content: {
      left: {
        main: {
          components: [
            {
              componentType: 'heading',
              headingLevel: '1',
              text: 'Max Payne (2001)'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Tarina:'
            },
            {
              componentType: 'text',
              text: 'Suomen tunnetuimman pelikäsikirjoittajan Sami Järven (1970-) luoma Max Payne mullisti pelialaa aikaa hidastavalla bullet time -tekniikallaan. Tekoälyltään tai grafiikaltaan Max Payne ei ollut ylivertainen, mutta sen tarinankerronta oli huippuluokkaa. Kyse ei ollut perinteisestä räiskintäpelistä, vaan yhtenäisestä tarinasta, jolla oli juoni, sarkastista dialogia ja jopa moraalia. Myös sarjakuvaromaanimaiset film -noir -välinäytökset olivat vallankumouksellisia. Max Payne oli Suomen ensimmäinen suuren budjetin peli, jonka myötä sen kehittäjä Remedy nousi maailmanmaineeseen.'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Tiesitkö että:'
            },
            {
              componentType: 'text',
              text: 'Max Paynesta julkaistiin kaksi jatko-osaa ja se päätyi myös Hollywood-elokuvaksi. Hauska anekdootti on sekin, että sarjan ensimmäisessä osassa pelihahmojen näyttelijät olivat Remedyn työntekijöitä ja käsikirjoittaja Sami Järvi itse antoi kasvonsa pelin päähenkilölle. Max Paynen jälkeen Remedy on julkaissut myös Alan Waken (2010) ja Quantum Breakin (2016), jotka molemmat ovat kansainvälisiä arvostelu- ja myyntimenestyksiä.'
            }
          ]
        },
        footnotes: {
          components: [
            {
              componentType: 'text',
              text: 'Pääsuunnittelija: Sami Järvi',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Julkaisija: Remedy / Rockstar Games / Feral Interactive',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Alusta: Microsoft Windows / PlayStation 2 / Xbox / Game Boy Advance / Macintosh',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Formaatti: CD / DVD',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Genre: Kolmannen persoonan ampumapeli / yksinpeli',
              style: 'small'
            },
          ]
        },
      },
      right: {
        components: [
          {
            componentType: 'video',
            src: MaxPayneVideo
          },
        ]
      }
    }
  },
  {
    index: 8,
    mainLayoutType: 'split',
    content: {
      left: {
        main: {
          components: [
            {
              componentType: 'heading',
              headingLevel: '1',
              text: 'Angry Birds (2009)'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Tarina:'
            },
            {
              componentType: 'text',
              text: 'Lintujen ja sikojen välisistä kahnauksista kertova Angry Birds on yksi populaarihistorian menestyneimmistä pelisarjoista. Se, miksi koko maailma sekosi yksinkertaisesta pulmapelistä, on mysteeri, mutta positiivinen sellainen. Yksi teoria on, että Angry Birdsin julkaisu osui ajankohtaan jolloin kuluttajien tottumukset olivat siirtymässä tietokone- ja konsolipeleistä mobiililaitteisiin. Pelin kehittäjästä Roviosta Angry Birds teki kansainvälisen supertähden. Suomalaisen peliteollisuuden vihaiset linnut nostivat lopullisesti maailman huipulle.'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Tiesitkö että:'
            },
            {
              componentType: 'text',
              text: 'Angry Birds oli 52. peli, joka Roviossa tehtiin. Jos se ei olisi onnistunut, koko yrityksen tulevaisuus olisi ollut uhattuna. Keskeinen tekijä läpimurrossa oli ohjelmointikieli-Lua, jolla peliä saatiin sujuvammaksi. Angry Birds -sarjasta on tehty lukemattomia jatko-osia ja koko illan animaatioelokuva. Vihaisten lintujen hassu huumori iskee edelleen.'
            }
          ]
        },
        footnotes: {
          components: [
            {
              componentType: 'text',
              text: 'Pääsuunnittelija: Jaakko Iisalo / Rovio',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Julkaisija: Clickgamer.com / Chillingo Ltd.',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Alusta: Erilaiset älypuhelimet / tabletit / pelikonsolit',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Formaatti: Internetin verkkokaupat / blu-ray disc',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Genre: Pulmapeli / yksinpeli',
              style: 'small'
            },
          ]
        },
      },
      right: {
        components: [
          {
            componentType: 'video',
            src: AngryBirdsVideo
          },
        ]
      }
    }
  },
  {
    index: 9,
    mainLayoutType: 'split',
    content: {
      left: {
        main: {
          components: [
            {
              componentType: 'heading',
              headingLevel: '1',
              text: 'Clash of Clans (2012)'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Tarina:'
            },
            {
              componentType: 'text',
              text: 'Clash of Clans tulee jäämään maailmanhistoriaan yhtenä kaikkien aikojen menestyneimmistä muotoilutuotteista. Supersuosio perustuu kahteen asiaan. Siihen, että pelin kehittäjä Supercell onnistui houkuttelemaan pelaajiksi myös niitä, jotka eivät aikaisemmin olleet innostuneet mobiilipeleistä. Ja siihen, että merkittävä osa Clash of Clansin pelaajista on ollut valmis ostamaan myös pelin maksullista sisältöä. Vaikka yksittäiselle pelaajalle nuo mikrosummat ovat usein pieniä, yhdessä niistä muotoutuu valtava tuloerä. Rovion tavoin Supercell onnistui siinä, missä muotoilijat usein epäonnistuvat: Kaupallistamaan tuotteensa.'
            },
            {
              componentType: 'heading',              
              headingLevel: '2',
              text: 'Tiesitkö että:'
            },
            {
              componentType: 'text',
              text: 'Clash of Clansin perusideana on rakentaa oma kylä, liittyä klaaniin ja laajentaa sitten omistuspohjaa valtaamalla toisten pelaajien kyliä hyökkäämällä. Ilkka Paanasen johtama Supercell on malliesimerkki siitä, miten suunnittelijat ja yritykset voivat halutessaan murtautua ulos omasta genrestään ja osallistua aktiivisesti yhteiskunnalliseen keskusteluun.'
            }
          ]
        },
        footnotes: {
          components: [
            {
              componentType: 'text',
              text: 'Pääsuunnittelija: Supercell',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Julkaisija: Supercell',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Alusta: iOS / Android',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Formaatti: Mobiilipeli',
              style: 'small'
            },
            {
              componentType: 'text',
              text: 'Genre: Strategiapeli / moninpeli',
              style: 'small'
            },
          ]
        },
      },
      right: {
        components: [
          {
            componentType: 'video',
            src: ClashOfClansVideo
          },
        ]
      }
    }
  },
  {
    index: 10,
    mainLayoutType: 'full',
    content: {
      components: [
        {
          componentType: 'video',
          src: ClosingTitleVideo,
          bgColor: '#0000FF'
        }
      ]
    }
  }
]

export default SlidesFi



// WEBPACK FOOTER //
// ./src/SlidesFi.js